/** Shared homepage wording for the hero, metadata and generated sharing card. */
export const HOME_COPY = {
  headline: ["One business.", "One Twin.", "Any AI."],
  lead: "Your Twin connects the records, relationships and business rules spread across your systems, giving your team and AI tools a shared understanding of how your business works. Ask questions, check the sources and put that understanding to work.",
  description: "Your Twin connects business records, relationships and rules into a shared understanding for your team and AI tools. Ask questions and check the sources.",
  closing: "Start with the question your team keeps chasing.",
} as const;
